import { portalMode } from './portal'

const apiUrl = import.meta.env.VITE_API_URL as string | undefined

if (!apiUrl) {
  throw new Error('VITE_API_URL is not set. Copy .env.example to .env.local.')
}

// On an agency's portal address the API is served under that same address.
const api = portalMode ? `${window.location.origin}/api/v1` : apiUrl.replace(/\/$/, '')

export const env = {
  appName: (import.meta.env.VITE_APP_NAME as string | undefined) ?? 'Arva SEO',
  /** e.g. http://localhost:8000/api/v1 */
  apiUrl: api,
  /** e.g. http://localhost:8000 — used for Sanctum's CSRF cookie endpoint. */
  apiOrigin: new URL(api).origin,
  /**
   * The help center and support tickets, e.g. https://support.arvaseo.com. Empty (local
   * development, staging): tickets open at /tickets in this app instead.
   */
  supportUrl: ((import.meta.env.VITE_SUPPORT_URL as string | undefined) ?? '').replace(/\/$/, ''),
  /** The CSRF cookie's name: staging's differs from production's (XSRF-TOKEN on .arvaseo.com). */
  xsrfCookie: (import.meta.env.VITE_XSRF_COOKIE as string | undefined) || 'XSRF-TOKEN',
  /** The app's own address, for links back to it from the support site. */
  appUrl: ((import.meta.env.VITE_APP_URL as string | undefined) || window.location.origin).replace(/\/$/, ''),
} as const
